import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO, { BreadcrumbSchema } from "../components/SEO";
import { BRAND, CONTACT } from "../lib/content";

export default function Privacy() {
  return (
    <>
      <SEO title="Privacy Policy" description={`Privacy policy for ${BRAND.legalName}`} path="/privacy" />
      <BreadcrumbSchema items={[{ name: "Home", url: "https://bcpeabody.com/" }, { name: "Privacy Policy", url: "https://bcpeabody.com/privacy" }]} />
      <Nav />

      <section className="pt-32 pb-10 bg-cream-light">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10">
          <div className="text-[11px] tracking-[0.18em] uppercase mb-5 text-copper">Legal</div>
          <h1 className="font-serif font-medium text-ink tracking-tight leading-[1.05]" style={{ fontSize: "clamp(34px, 5vw, 56px)" }}>
            Privacy Policy
          </h1>
          <p className="mt-6 text-ink/70 text-sm">Effective date: October 2026</p>
        </div>
      </section>

      <section className="bg-cream-light pb-24">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10 space-y-5 text-ink/85 leading-relaxed" style={{ fontSize: 16 }}>
          <p>{BRAND.legalName} ("BCPeabody," "we") respects your privacy. This policy explains what we collect through bcpeabody.com and how we use it.</p>

          <p><strong>Information we collect.</strong> When you use our contact or application forms, we collect what you choose to send: your name, phone number, email, project details, budget range, how you heard about us, and any resume link you provide. Like most websites, we also collect basic technical information such as browser type, pages visited and general location, through cookies and similar tools.</p>

          <p><strong>How we use it.</strong> We use your information to respond to you, prepare proposals, evaluate job applications, run conflict checks for expert witness inquiries, and improve our website. We do not sell your personal information.</p>

          <p><strong>Sharing.</strong> We share information only with service providers who help us run the website and email (such as our hosting and email providers), with professionals we work with when needed to respond to your request, or when required by law.</p>

          <p><strong>Expert witness inquiries.</strong> Information from attorneys and their clients is kept confidential and used only for conflict checks and engagement discussions.</p>

          <p><strong>Retention.</strong> We keep information only as long as needed for the purpose it was collected or as required for business and legal records.</p>

          <p><strong>Your choices.</strong> You can ask us to access, correct or delete your information by emailing <a href={`mailto:${CONTACT.email}`} className="text-copper">{CONTACT.email}</a>. You can block cookies in your browser settings.</p>

          <p><strong>Children.</strong> This site is not directed to children under 13, and we do not knowingly collect their information.</p>

          <p><strong>Changes.</strong> We may update this policy and will post the new version here with its effective date.</p>

          <p><strong>Contact.</strong> {BRAND.legalName}, mailing address {CONTACT.mailingAddress} · <a href={`mailto:${CONTACT.email}`} className="text-copper">{CONTACT.email}</a> · <a href={CONTACT.phoneHref} className="text-copper">{CONTACT.phone}</a></p>
        </div>
      </section>
      <Footer />
    </>
  );
}
